<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{'title.select-an-option' | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>
<div class="modal-body">
  <div class="alert alert-warning" role="alert">
    {{'hint.please-select-one-of-the-following-options' | translate}}
  </div>
  <div>
    <div class="card">
      <div class="card-body">

        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6  col-xl-4 d-grid gap-2" *ngFor="let option of values">
            <button class="btn btn-outline-primary m-2 position-relative" (click)="setSelected(option)">
              <i class="fas fa-check-circle me-2" *ngIf="option === selected"></i>
              {{translatekey+"."+option | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">
      {{'button.close' | translate}}
    </button>
  </div>
</div>